import { useDispatch } from "react-redux";
import { Dispatch } from "redux";
import { FunderDetailsActions } from "../actions/types/funderDetails";

export const useFunderDetailsDispatch = (): Dispatch<FunderDetailsActions> =>
  useDispatch();
